<template>
  <v-stepper v-model="step" vertical @click.stop>
    <!--    <v-stepper-step color="#9c7438" :complete="step > 1" step="1">電話號碼獲取驗證碼</v-stepper-step>
        <v-stepper-content step="1">
          <v-btn v-if="rules.validPhoneNumber(phone) === true" color="#9c7438" dark @click="getCode">下一步</v-btn>
        </v-stepper-content>-->

    <v-stepper-step color="#9c7438" :complete="step > 1" step="1">電話號碼獲取驗證碼</v-stepper-step>
    <v-stepper-content step="1">
      <v-text-field v-model="phone"
                    label="Solo"
                    counter="8"
                    prefix="+852"
                    type="phone"
                    placeholder="電話號碼"
                    :rules="[rules.validPhoneNumber]"
                    solo>
      </v-text-field>
      <v-btn v-if="rules.validPhoneNumber(phone) === true" color="#9c7438" dark @click="getCode">下一步</v-btn>
    </v-stepper-content>

    <v-stepper-step color="#9c7438" :complete="step > 2" step="2">輸入驗證碼</v-stepper-step>
    <v-stepper-content step="2">
      <v-text-field v-model="code"
                    label="Solo"
                    counter="6"
                    type="phone"
                    validate-on-blur
                    placeholder="驗證碼"
                    :rules="[rules.validCode]"
                    solo>
      </v-text-field>
      <div style="font-size: 12px" v-if="verifyError" class="red--text mt-0">{{ verifyError }}</div>
      <v-btn color="#9c7438" dark @click="verify">驗證</v-btn>
      <v-btn text @click="step = 1">上一步</v-btn>
    </v-stepper-content>

    <v-stepper-step color="#9c7438" :complete="step > 3" step="3">請選擇試做項目</v-stepper-step>
    <v-stepper-content step="3">
      <v-select :rules="[rules.validTrial]"
                v-model="trial"
                :items="items"
                chips
                label="按此選擇"></v-select>
      <v-btn color="#9c7438" dark @click="submit">提交</v-btn>
      <v-btn text @click="step = 1">上一步</v-btn>
    </v-stepper-content>
    <div id="sign-in-button"></div>
  </v-stepper>
</template>

<script>
import firebase       from '../firebase'
import {mapMutations} from 'vuex'
import $              from 'jquery'

export default {
  methods : {
    ...mapMutations(['setUser']),
    async getCode () {
      try {
        let t = this
        if (!window.recaptchaVerifier) {
          window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('sign-in-button', {
            'size'             : 'invisible',
            'callback'         : function (response) {
              // reCAPTCHA solved, allow signInWithPhoneNumber.
            },
            'expired-callback' : () => {
            }
          })
        }
        $('body').addClass('busy')
        let confirmationResult = await firebase.auth()
                                               .signInWithPhoneNumber('+852' + t.phone, window.recaptchaVerifier)

        window.confirmationResult = confirmationResult
        t.step = 2
        $('body').removeClass('busy')
      } catch (e) {
        $('body').removeClass('busy')
        console.error(e)
      }
    },
    async verify () {
      try {
        let t = this
        $('body').addClass('busy')
        t.verifyResult = await window.confirmationResult.confirm(t.code)
        t.step = 3
        $('body').removeClass('busy')
      } catch (e) {
        $('body').removeClass('busy')
        this.verifyError = '驗證碼錯誤'
        console.error(e)
      }
    },

    async submit () {
      $('body').addClass('busy')
      try {
        const t = this
        if (t.verifyResult.user) {
          let db = firebase.firestore()
          let authUser = t.verifyResult.user
          let tokenCntDoc = db.collection('trials').doc("count")
          let userDoc = db.collection('trials').doc(authUser.phoneNumber)
          let user = null
          console.log('get user record')
          let userDBRecord = await userDoc.get()
          if (userDBRecord.exists) {
            user = { ...userDBRecord.data() }
          } else {
            let userToken = await db.runTransaction(function (transaction) {
              // This code may get re-run multiple times if there are conflicts.
              return transaction.get(tokenCntDoc).then(function (cnt) {
                if (!cnt.exists) {
                  //	continue
                }
                let _total = cnt.data().total + 1
                const timestamp = firebase.firestore.FieldValue.serverTimestamp();

                transaction.update(tokenCntDoc, {
                  total       : _total,
                  lastUpdated : timestamp
                })
                transaction.set(userDoc, {
                  token     : _total,
                  phone     : authUser.phoneNumber,
                  trial     : t.trial,
                  timeStamp : timestamp
                })
                return _total
              })
            })

            user = {
              token : userToken,
              phone : '+852' + t.phone,
              trial : t.trial
            }
          }
          this.setUser(user)
          // console.log('setUser in verification done')
        }
        $('body').removeClass('busy')
      } catch (e) {
        console.log(e)
        $('body').removeClass('busy')
      }
    }
  },
  data    : () => ({
    //
    verifyError : '',
    phone       : '',
    code        : '',
    step        : 1,
    trial       : '',
    trials      : [],
    items       : ['再生膠原BB肌 $880', '️毛孔救星 $680', '激光脫墨／疣 $198(3粒)', '皇牌美白槍 $580', '皇牌針清 $480',
      '初生透亮肌 680',],
    rules       : {
      validPhoneNumber (value) {
        if (!value || value.length !== 8 || !parseInt(value)) {
          return '請輸入正確電話'
        } else {
          return true
        }
      },
      validCode (value) {
        if (!value || value.length !== 6 || !parseInt(value)) {
          return '輸入6位數字驗證碼'
        } else {
          return true
        }
      },
      validTrial (value) {
        if (!value) {
          return '請選擇試做項目'
        } else {
          return true
        }
      }
    }
  }),
}
</script>

<style scoped>

</style>
